var Custom = (function () {
  return {
    init: function () {
      this.jump_to_next();
      this.show_hide_content();
      //this.fix_header_height();
      // this.init_swiper();
      this.init_parallax();
      this.scroll_to_top();
      this.scroll_button();
    },
    scroll_to_top: function () {
      var offset = 300;
      var duration = 500;

      if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {  // ios supported
        $(window).bind("touchend touchcancel touchleave", function (e) {
          if ($(this).scrollTop() > offset) {
            $('.scroll-to-top').fadeIn(duration);
          } else {
            $('.scroll-to-top').fadeOut(duration);
          }
        });
      } else {  // general 
        $(window).scroll(function () {
          if ($(this).scrollTop() > offset) {
            $('.scroll-to-top').fadeIn(duration);
          } else {
            $('.scroll-to-top').fadeOut(duration);
          }
        });
      }

      $('.scroll-to-top').click(function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, duration);
        return false;
      });
    },
    jump_to_next: function () {
      var $el = $("#jump-to-next");
      if (!$el.length) {
        return;
      }
      $el.on("click", function () {
        var $b = $(".shopify-section:eq(1)", ".main-content");

        $('html,body').animate({
          scrollTop: $b.offset().top
        }, 'slow');
      });
    },
    show_hide_content: function () {
      var $els = $("*[data-custom-toggle]");
      if ($els.length > 0) {
        $("*[data-custom-toggle]").on('click', function (e) {
          e.preventDefault();
          var that = $(this);

          var element = that.data("element");
          var limit = that.data("limit");
          var parent = that.closest(that.data('parent'));
          var children = $(element, parent);

          if (children.length <= limit) {
            that.remove();
            return;
          }

          if (typeof that.data("current") === "undefined" || that.data("current") == "less") {
            that.data("current", "more").text(that.data("text-less"));
            $(element, parent).not(":first").removeAttr("hidden", "hidden");
          } else {
            that.data("current", "less").text(that.data("text-more"));
            $(element, parent).not(":first").attr("hidden", "hidden");
          }
        }).each(function (e) {
          var that = $(this);
          var d = that.data("text-default");
          if (typeof d !== "undefined") {
            that.text(that.data("text-" + d));
          }
        }).trigger("click");
      }
    },
    fix_header_height: function () {
      var $div = $(".header.sticky-header");
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "class") {
            var attributeValue = $(mutation.target).prop(mutation.attributeName);
            if (!$(mutation.target).hasClass("scrolled") && !$("body").hasClass("has-slideshow-full-window")) {
              $("body").css("padding-top", "120px");
            }
          }
        });
      });
      observer.observe($div[0], {
        attributes: true
      });
    },
    init_swiper: function () {
      if ($(".swiper-container").length && typeof Swiper !== undefined) {
        $(".swiper-container").each(function () {
          var swiper = new Swiper($(this), {
            slidesPerView: 5
                    /*,
                     navigation: {
                     nextEl: '.swiper-button-next',
                     prevEl: '.swiper-button-prev',
                     }*/
          });
        });
      }
    },
    init_parallax: function () {
      if ($(".parallax").length && typeof simpleParallax !== undefined) {
        var image = document.getElementsByClassName('parallax');
        new simpleParallax(image, {
          delay: .6,
          transition: 'cubic-bezier(0,0,0,1)',
          scale: 1.1
        });
      }
    },
    scroll_button: function () {
      var duration = 500;

      $('.scroll-button').click(function (e) {
        e.preventDefault();

        var h = $('#site-header').height();
        var id = $(this).attr('href');
        var el = $(id)
        if (el) {
          $('html, body').animate({
            scrollTop: el.offset().top - h
          }, duration);
        }
        return false;
      });
    },
  };
})();

jQuery(document).ready(function () {
  Custom.init();
});

// blog battery
$('.gp-blog-table-line .bar').each(function() {
  for (i = 0; i < 73; i++) {
    $(this).append('<div></div>');
  }
});

// accordion
var accordion = {
  el: '',
  el_header: '',
  el_body: '',
  selected: 0,

  init: function(el) {
    accordion.el = el;
    accordion.el_header = $('> .product-accordions-header', accordion.el);
    accordion.el_body = $('> .product-accordions-body', accordion.el);
    
    accordion.el_header.on('click', function(e) {
      $(this).toggleClass('active');
    });
  },
};
accordion.init($('.product-accordions'));